import '../src/lib/publicPath';
import 'core-js/stable';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Vuelidate from 'vuelidate';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import '../src/lib/basePackConfig';
import VueMask from 'v-mask';

import OptOut from '../src/components/opt_out/OptOut.vue';

import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(Vuetify);
Vue.use(Vuelidate);
Vue.use(VueMask);

const elementAnchor = document.getElementById('opt-out-app');
const props = JSON.parse(elementAnchor.getAttribute('optOutProps'));

Vue.use(VueReCaptcha, { siteKey: props['recaptchaSiteKey'].toString() });

// eslint-disable-next-line no-new
new Vue({
  el: '#opt-out-app',
  vuetify: new Vuetify(),
  render: (h) => h(OptOut, { props }),
});
